export class ProjectFilter
{
    name:string;
    deliveryManager:number;
    startDate:string;
    endDate:string;
}